import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ManagerNavbar from "../Layout/ManagerNavbar";
import { parseISO, isWithinInterval, addDays } from "date-fns";
import { FaTasks, FaClock, FaUsers, FaFileAlt, FaChartLine, FaChartBar, FaStopwatch } from "react-icons/fa";
import { PieChart, Pie, BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, } from "recharts";
import TermsConditionsPopup from "../components/TermsConditionsPopup";
import API_BASE_URL from "../config";

const ManagerDashboard = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({ name: "Manager" });
  const [loading, setLoading] = useState(true);

  const [teamMembers, setTeamMembers] = useState(0);
  const [myTeam, setMyTeam] = useState([]);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [dashboardData, setDashboardData] = useState({ leaves: [] });
  const [pendingLeaves, setPendingLeaves] = useState(0);
  const [documents, setDocuments] = useState(0);
  const [upcomingLeaves, setUpcomingLeaves] = useState(0);
  const [ongoingTasks, setOngoingTasks] = useState(0);
  const [Timesheet, setTimesheet] = useState(0);
  const [financialYear, setFinancialYear] = useState("");
  const [filteredLeaves, setFilteredLeaves] = useState([]);
  const [remainingLeaves, setRemainingLeaves] = useState(0);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveSummary, setLeaveSummary] = useState([]);
  const [remainingLeaveDetails, setRemainingLeaveDetails] = useState([]);


  const userId = localStorage.getItem("employeeId");


  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(`${API_BASE_URL}/api/company-info`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then(res => res.json())
      .then(data => {


        // API returns array → take first record
        const company = Array.isArray(data) ? data[0] : data;

        if (!company?.financialYear) {
          console.warn("No financialYear found");
          return;
        }

        setFinancialYear(company.financialYear);
      })

      .catch(err => console.error("Error fetching company info:", err));
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const managerId = localStorage.getItem("employeeId");
    const userId = localStorage.getItem("userId");
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    const status = localStorage.getItem("status") || "";

    if (!token || status.toUpperCase() !== "ACTIVE" || !roles.includes("ROLE_MANAGER")) {
      navigate("/");
      return;
    }

    // ---------------- PROFILE ----------------
    fetch(`${API_BASE_URL}/api/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => setProfile({ name: data.name || "Manager" }))
      .catch(() => setProfile({ name: "Manager" }));

    // ---------------- TEAM METRICS ----------------
    fetch(`${API_BASE_URL}/api/manageteam/reporter/${managerId}`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then(res => res.json())
      .then(data => {
        const arr = Array.isArray(data) ? data : [];

        // 🔹 filter unique by employeeId
        const uniqueArr = Array.from(
          new Map(arr.map(item => [item.employeeId, item])).values()
        );

        setMyTeam(uniqueArr);
        setTeamMembers(uniqueArr.length);
      })
      .catch(err => console.error(err));


    // ---------------- UPCOMING LEAVES ----------------
    // fetch(`${API_BASE_URL}/api/leaves/team-leaves`, {
    //   headers: {
    //     Authorization: "Bearer " + token,
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then(res => {
    //     if (!res.ok) throw new Error("Failed to fetch team leaves");
    //     return res.json();
    //   })
    //   .then(data => {
    //     const leavesArray = Array.isArray(data) ? data : [];
    //     const now = new Date();
    //     const in7Days = addDays(now, 7);

    //     const upcomingApproved = leavesArray.filter(
    //       leave =>
    //         leave.status?.toLowerCase() === "approved" &&
    //         leave.startDate &&
    //         isWithinInterval(parseISO(leave.startDate), { start: now, end: in7Days })
    //     );

    //     setUpcomingLeaves(upcomingApproved.length);
    //   })
    //   .catch(err => console.error("❌ Error loading team leaves:", err));

    // // ---------------- PENDING LEAVES ----------------
    // fetch(`${API_BASE_URL}/api/leaves/team-leaves`, {
    //   headers: {
    //     Authorization: "Bearer " + token,
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then(res => {
    //     if (!res.ok) throw new Error("Failed to fetch team leaves");
    //     return res.json();
    //   })
    //   .then(data => {
    //     const leavesArray = Array.isArray(data) ? data : [];
    //     const pendingCount = leavesArray.filter(
    //       leave => leave.status?.toLowerCase() === "pending"
    //     ).length;

    //     setPendingLeaves(pendingCount);
    //   })
    //   .catch(err => console.error("❌ Error loading team leaves:", err));

    // ---------------- TASKS ----------------
    // fetch(`${API_BASE_URL}/api/tasks/reported-by/${managerId}`, {
    //   headers: {
    //     Authorization: "Bearer " + token,
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then(res => {
    //     if (!res.ok) throw new Error("Failed to fetch tasks");
    //     return res.json();
    //   })
    //   .then(data => {
    //     const tasksArray = Array.isArray(data) ? data : [];
    //     const inProgressCount = tasksArray.filter(
    //       task => task.status?.toUpperCase() === "IN_PROGRESS"
    //     ).length;

    //     setOngoingTasks(inProgressCount);
    //   })
    //   .catch(err => console.error("❌ Error loading tasks:", err));



    fetch(`${API_BASE_URL}/api/tasks/employee/${managerId}/pending-count`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setOngoingTasks(data.pendingCount || 0));

    // ---------------- TIMESHEETS (DTO FIX HERE) ----------------
    fetch(`${API_BASE_URL}/api/manageteam/reporter/${managerId}`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then(res => res.json())
      .then(async teamData => {
        const arr = Array.isArray(teamData) ? teamData : [];

        // ✅ Rebuild employees from DTO
        const employees = arr
          .map(item => {
            if (!item?.employeeId) return null;
            return {
              id: item.employeeId,
              firstName: item.employeeFirstName,
              lastName: item.employeeLastName,
            };
          })
          .filter(Boolean);

        const employeeIds = [...new Set(employees.map(e => e.id))];

        const logPromises = employeeIds.map(id =>
          fetch(`${API_BASE_URL}/api/worklogs/employee/${id}`, {
            headers: { Authorization: "Bearer " + token },
          })
            .then(res => res.json())
            .catch(() => [])
        );

        const results = await Promise.all(logPromises);
        const allLogs = results.flat();

        const now = new Date();
        const startOfPreviousMonth = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1
        );

        const filtered = allLogs.filter(log => {
          const logDate = new Date(log.date);
          return logDate >= startOfPreviousMonth && logDate <= now;
        });

        const unique = new Set(filtered.map(l => l.employeeId));
        setTimesheet(unique.size);
      })
      .catch(err => console.error("❌ Error loading timesheets:", err));

    setLoading(false);
  }, [navigate]);


  const fetchTeamAvailLeaves = async () => {
    const token = localStorage.getItem("token");
    if (!token || !financialYear) return;

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/leave-transactions/team-avail?financialYear=${financialYear}`,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) throw new Error("Failed to fetch team leaves");

      const data = await res.json();
      const leaves = Array.isArray(data) ? data : [];

      // 🔁 normalize backend → UI
      const mappedLeaves = leaves.map(l => ({
        ...l,
        status: l.leaveStatus,
      }));

      // ===============================
      // 📅 UPCOMING APPROVED (next 7 days)
      // ===============================
      const now = new Date();
      const in7Days = addDays(now, 7);

      const upcomingApproved = mappedLeaves.filter(l =>
        l.status === "APPROVED" &&
        l.startDate &&
        isWithinInterval(parseISO(l.startDate), {
          start: now,
          end: in7Days,
        })
      );

      setUpcomingLeaves(upcomingApproved.length);

      // ===============================
      // ⏳ PENDING COUNT
      // ===============================
      const pendingCount = mappedLeaves.filter(
        l => l.status === "PENDING"
      ).length;

      setPendingLeaves(pendingCount);

      // ===============================
      // 📊 Dashboard table data
      // ===============================
      setDashboardData({ leaves: mappedLeaves });

      // default → current month
      const currentMonthLeaves = mappedLeaves.filter(l => {
        const start = new Date(l.startDate);
        return (
          start.getMonth() === now.getMonth() &&
          start.getFullYear() === now.getFullYear()
        );
      });

      setFilteredLeaves(currentMonthLeaves);

    } catch (err) {
      console.error("❌ Error loading team leaves:", err);
    }
  };

  useEffect(() => {
    fetchTeamAvailLeaves();
  }, [financialYear]);


  const fetchLeaveSummary = async () => {
    const token = localStorage.getItem("token");
    if (!token || !financialYear) {

    }

    try {
      const [typesRes, summaryRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/leave-types/all`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(
          `${API_BASE_URL}/api/leave-transactions/summary/${userId}`,
          {
            params: { financialYear }, // ✅ FY applied
            headers: { Authorization: `Bearer ${token}` },
          }
        ),
      ]);

      const summaryData = Array.isArray(summaryRes.data)
        ? summaryRes.data
        : [];


      setLeaveTypes(typesRes.data);


      setLeaveSummary(summaryData);


      setRemainingLeaveDetails(summaryData);


      const totalRemaining = summaryData.reduce(
        (sum, item) => sum + (item.remaining || 0),
        0
      );
      setRemainingLeaves(totalRemaining);

    } catch (err) {
      console.error("❌ Error fetching leave summary:", err);

    }
  };

  useEffect(() => {
    fetchLeaveSummary();
  }, [financialYear]);


  if (loading) return <div style={{ textAlign: "center", marginTop: "20%" }}>Loading...</div>;

  return (
    <>
      <TermsConditionsPopup />
      <div style={styles.container}>
        {/* ✅ Fixed Navbar */}
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          <ManagerNavbar />
        </div>

        {/* Dashboard Content */}
        <div style={{ ...styles.content, paddingTop: "130px" }}>
          <h2 style={styles.heading}>👋 Welcome, {profile.name}</h2>

          <div style={styles.cardGrid}>
            <DashboardCard
              title="Team Members"
              subtitle={`${teamMembers} Members`}
              icon={<FaUsers size={28} color="#007bff" />}
              path="/teampage"
            />
            <DashboardCard
              title="My Tasks"
              subtitle={`${ongoingTasks} In To Do`}
              icon={<FaTasks size={28} color="#007bff" />}
              path="/viewtaskss"
            />
            <DashboardCard
              title="Upcoming Approved Leaves"
              subtitle={`${upcomingLeaves} in next 7 days`}
              icon={<FaClock size={28} color="#ff6b6b" />}
              path="/managerteamleaves"
            />
            <DashboardCard
              title="Pending Leaves for Approval"
              subtitle={`${pendingLeaves} Requests`}
              icon={<FaClock size={28} color="#17a2b8" />}
              path="/pendingmanagerteamleaves"
            />
            <DashboardCard
              title="Remaining Leaves"
              subtitle={`${remainingLeaves} Leaves`}
              icon={<FaStopwatch size={30} color="#28a745" />}
            />
            <DashboardCard
              title="Timesheets"
              subtitle={`${Timesheet} Timesheet`}
              icon={<FaChartBar size={28} color="#007bff" />}
              path="/teamtimesheetgrid"
            />
          </div>

          <div style={styles.chartSection}>
            <h4 style={{ marginBottom: "15px", fontSize: "20px", fontWeight: "600" }}>
              Team Overview
            </h4>

            <div style={styles.chartsContainer}>

              {/* Pie Chart – Leave Status */}
              <div style={styles.chartBox}>
                <h5 style={styles.chartTitle}>Leave Status Overview</h5>
                <ResponsiveContainer width="100%" height={250}>
                  <PieChart>
                    <Pie
                      data={[
                        { name: "Pending", value: pendingLeaves },
                        { name: "Upcoming", value: upcomingLeaves },
                      ]}
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"

                    />
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* 📝 Leave Summary Card */}
              <div style={styles.summaryCard}>
                <h5 style={styles.summaryHeader}>Leave Summary</h5>

                {leaveSummary.map((item, index) => (
                  <div key={index} style={styles.summaryRow}>
                    <span>{item.leaveType}</span>
                    <strong>
                      {item.remaining}{" "}
                      <span style={styles.appliedBox}>[{item.applied}]</span>
                    </strong>
                  </div>
                ))}

                {/* Total Section */}
                <div style={styles.summaryTotalRow}>
                  <strong>Total</strong>
                  <strong>
                    {leaveSummary.reduce((sum, item) => sum + item.remaining, 0)}{" "}
                    <span style={styles.appliedBox}>
                      [
                      {leaveSummary.reduce((sum, item) => sum + item.applied, 0)}
                      ]
                    </span>
                  </strong>
                </div>
              </div>

              {/* Bar Chart – Ongoing Tasks */}
              <div style={styles.chartBox}>
                <h5 style={styles.chartTitle}>Tasks In To Do</h5>
                <ResponsiveContainer width="100%" height={250}>
                  <BarChart data={[{ name: "Tasks", value: ongoingTasks }]}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="value" fill="#82ca9d" />
                  </BarChart>
                </ResponsiveContainer>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );

};

const DashboardCard = ({ title, subtitle, icon, path }) => {
  const navigate = useNavigate();
  return (
    <div style={styles.card} onClick={() => path && navigate(path)}>
      <div>
        <h5 style={styles.cardTitle}>{title}</h5>
        <p style={styles.cardSubtitle}>{subtitle}</p>
      </div>
      <div>{icon}</div>
    </div>
  );
};

// Internal CSS
const styles = {
  container: { minHeight: "100vh", background: "#f5f6fa" },
  content: { padding: "30px" },
  heading: { fontWeight: "600", color: "#2f3640", marginBottom: "30px" },
  cardGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  cardTitle: { margin: 0, fontWeight: "600", color: "#333" },
  cardSubtitle: { margin: 0, color: "#888", marginTop: "5px" },
  chartSection: { marginTop: "40px", background: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 3px 10px rgba(0,0,0,0.1)" },
  chartPlaceholder: { height: "200px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", border: "2px dashed #ccc", borderRadius: "12px" },

  chartsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "25px",
    marginTop: "10px",
  },

  chartBox: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
  },

  chartTitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "10px",
  },

  summaryCard: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
    marginBottom: "0px",
    border: "1px solid #e5e5e5",
    flex: 1,

  },

  summaryHeader: {
    fontWeight: "600",
    marginBottom: "15px",
    paddingBottom: "8px",
    borderBottom: "1px solid #ddd",
    color: "#333",
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
    fontSize: "15px",
    borderBottom: "1px dotted #eee",
  },

  summaryTotalRow: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "10px",
    marginTop: "10px",
    borderTop: "2px solid #ccc",
    fontSize: "16px",
  },

  appliedBox: {
    fontSize: "14px",
    color: "#777",
  },

};

export default ManagerDashboard;
